import { render, staticRenderFns } from "./StaffDiv.vue?vue&type=template&id=35235138&"
import script from "./StaffDiv.vue?vue&type=script&lang=ts&"
export * from "./StaffDiv.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports